module.exports = __webpack_public_path__ + "static/media/favourite-brand-bg.cc9a950b.png";